import React from 'react';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

interface IProps {
	checked: boolean;
	onChange: () => void;
}

export const RememberMyChoice: React.FC<IProps> = ({ checked, onChange }) => (
	<Checkbox className="!ml-0" onChange={onChange} checked={checked} data-test="RememberMyChoice">
		<Text size="xs" theme="neutralLight" translationNameSpace="modals" translationKey="rememberMyChoice" />
	</Checkbox>
);
